import styles from "./Header.module.css";

function Header() {
    return (
        <header className={styles.header}>
            <h1>Calculadora Impositiva</h1>
        </header>
    )
}

export default Header;